// Components
import measureElementDecorator from '../components/measurementsStore/elementMeasurements/measureElementDecorator';
import ElementPresentational from './ElementPresentational';
import { zoomStateContextConsumer } from '../canvas/zoom/ZoomStateContext';

// Ensures that preview elements get measured
export default zoomStateContextConsumer(measureElementDecorator(ElementPresentational));
